import styled from 'styled-components';
import { Button, Icon } from 'semantic-ui-react';
import { theme } from '../../../styles/theme';

export const MessageBar = styled.div`
  flex: 0 0 102px;
  width: 100%;
  background-color: #f2f5fc;
  position: relative;
  display: block;
`;

export const MessageTypeMenu = styled.div`
  width: 304px;
  height: 32px;
  padding: 4px 12px;
`;

export const MessageControl = styled.div`
  float: left;
  height: 28px;
  padding-top: 4px;
  display: flex;
`;

export const HiddenUploadButton = styled.input`
  opacity: 0;
  z-index: -1;
`;

export const UploadIconContainer = styled.div`
  margin-right: 8px;
`;

// style for upload image button
export const ControlIcon = styled(Icon)`
  &&& {
    height: 16px;
    width: 16px;
    cursor: pointer;
    color: ${(props) =>
      props.defaultValue === 'grey'
        ? '#8a94bd'
        : props.defaultValue === 'blue'
          ? theme.colors.mainBlue
          : '#cccccc'};
    opacity: ${(props) => (props.defaultalue === 'blue' ? '0.5' : '1')};
    margin-left: 8px;
  }
`;
export const ButtonGroups = styled.div`
  float: right;
`;

// disable submit button when text is 0 or text longer than 4000
export const MessageSubmitButton = styled(({ ...props }) => (
  <Button {...props} />
))`
  &&& {
    border-radius: 4px;
    border: solid 1px #f7f9fa;
    background: linear-gradient(
      108deg,
      ${theme.colors.mainBlue} 1%,
      #0076ea 118%
    );
    opacity: ${(props) => (props.defaultChecked ? '1' : '0.5')};
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
    color: #ffffff;
    padding: 3px 8px;
  }
`;

export const MessageCancelButton = styled(({ ...props }) => (
  <Button {...props} />
))`
  &&& {
    border-radius: 2px;
    border: solid 1px #0076ea;
    background-color: #f7f9fa;

    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: #0076ea;
    padding: 2px 7px;
  }
`;
